// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* settings.css — Settings shell + profile hero.
 *
 * Loaded from Settings.jsx AFTER responsive/pages/Settings.css, so the rail
 * overrides below outrank that file's \`.settings-rail-item.active\` rules at
 * equal specificity without needing !important.
 *
 * MOTION BUDGET
 * Everything here animates only opacity, transform and stroke-dashoffset, all
 * of which the compositor can handle without a re-layout. The shared
 * --mx-ease-glide curve comes from PageTransition.css (:root), which
 * DashboardLayout imports, so the whole dashboard eases identically. A literal
 * fallback is given everywhere in case that file is ever not loaded.
 */

/* ══ Profile hero ═══════════════════════════════════════════════════════════ */

.settings-hero {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  gap: 24px;
  align-items: center;
}

/* ── Avatar + completion ring ──────────────────────────────────────────────
 * The ring is an SVG rather than a conic-gradient so the sweep can be
 * transitioned: stroke-dashoffset is animatable, background-image is not.
 * Sized in one place via --hero-avatar so the ring, the image and the badge
 * can never drift out of alignment. */
.settings-hero__avatar-wrap {
  --hero-avatar: 112px;
  --hero-ring: 5px;
  position: relative;
  width: var(--hero-avatar);
  height: var(--hero-avatar);
  flex-shrink: 0;
}

.settings-hero__ring {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  /* -90deg puts 0% at twelve o'clock; without it the sweep starts at 3. */
  transform: rotate(-90deg);
  overflow: visible;
}

.settings-hero__ring-track {
  fill: none;
  stroke: var(--line, #e2e8f0);
  stroke-width: var(--hero-ring);
}

.settings-hero__ring-fill {
  fill: none;
  stroke: url(#settings-ring-gradient);
  stroke-width: var(--hero-ring);
  stroke-linecap: round;
  transition: stroke-dashoffset 900ms
    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));
}

/* Inset by the ring width plus a hair of breathing room, so the portrait never
   sits under the stroke. */
.settings-hero__avatar {
  position: absolute;
  inset: calc(var(--hero-ring) + 4px);
  border-radius: 50%;
  overflow: hidden;
  display: grid;
  place-items: center;
  background: var(--bg-inset, #f1f5f9);
  animation: settings-avatar-in 520ms
    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;
}

@keyframes settings-avatar-in {
  from {
    opacity: 0;
    /* Scale is acceptable here, unlike on text: a circular mark has no glyphs
       to re-rasterise, so it stays crisp throughout. */
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.settings-hero__avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Initials fallback. No portrait field exists on the account, so this is the
   real default rather than a placeholder graphic. */
.settings-hero__initials {
  font-size: 30px;
  font-weight: 600;
  letter-spacing: 0.01em;
  color: var(--brand-600, #7c3aed);
  -webkit-user-select: none;
          user-select: none;
}

.settings-hero__pct {
  position: absolute;
  right: -2px;
  bottom: -2px;
  min-width: 42px;
  padding: 3px 7px;
  border-radius: 999px;
  background: var(--surface, var(--bg-primary, #fff));
  box-shadow: 0 0 0 2px var(--surface, var(--bg-primary, #fff)), 0 2px 8px rgba(15, 23, 42, 0.14);
  font-size: 12px;
  font-weight: 600;
  text-align: center;
  color: var(--ink, #0f172a);
  display: none;
}

/* ── Hero copy ─────────────────────────────────────────────────────────── */

.settings-hero__body {
  min-width: 0;
}

.settings-hero__name {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: var(--ink, #0f172a);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settings-hero__email {
  display: block;
  margin-top: 2px;
  font-size: 13px;
  color: var(--t-400, #64748b);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.settings-hero__progress-label {
  margin-top: 14px;
  font-size: 12.5px;
  color: var(--t-500, #475569);
}

/* ── Checklist ─────────────────────────────────────────────────────────── */

.settings-hero__todo {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 12px 0 0;
  padding: 0;
  list-style: none;
}

.settings-hero__todo li {
  animation: settings-todo-in 380ms
    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;
}

/* Staggered so the list assembles rather than snapping in as one block. */
.settings-hero__todo li:nth-child(1) { animation-delay: 60ms; }
.settings-hero__todo li:nth-child(2) { animation-delay: 100ms; }
.settings-hero__todo li:nth-child(3) { animation-delay: 135ms; }
.settings-hero__todo li:nth-child(4) { animation-delay: 165ms; }
.settings-hero__todo li:nth-child(5) { animation-delay: 190ms; }
.settings-hero__todo li:nth-child(n + 6) { animation-delay: 210ms; }

@keyframes settings-todo-in {
  from { opacity: 0; transform: translate3d(0, 5px, 0); }
  to   { opacity: 1; transform: none; }
}

/* Each chip navigates to the tab that owns the field, so the list is a set of
   shortcuts, not just a report. */
.settings-hero__chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 11px 6px 9px;
  border: 1px solid var(--line, #e2e8f0);
  border-radius: 999px;
  background: var(--surface, var(--bg-primary, #fff));
  color: var(--t-500, #475569);
  font: inherit;
  font-size: 12.5px;
  cursor: pointer;
  transition:
    border-color 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),
    color 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),
    transform 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));
}

.settings-hero__chip:hover {
  border-color: var(--brand-600, #7c3aed);
  color: var(--ink, #0f172a);
  transform: translateY(-1px);
}

.settings-hero__chip:focus-visible {
  outline: 2px solid var(--brand-600, #7c3aed);
  outline-offset: 2px;
}

.settings-hero__chip svg {
  flex-shrink: 0;
  color: var(--t-400, #94a3b8);
}

.settings-hero__done {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-top: 12px;
  font-size: 13px;
  font-weight: 500;
  color: var(--ok, var(--success, #15803d));
}

/* ══ Rail: sliding active indicator ════════════════════════════════════════
 * Replaces the per-item \`background\` on .settings-rail-item.active. With the
 * background painted on each item, switching section snapped: one item's fill
 * vanished and another appeared in the same frame with nothing connecting
 * them. A single element now carries the fill and is moved between items.
 * Same technique as the main Sidebar. */

.settings-rail {
  position: relative;
}

.settings-rail__slider {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  z-index: 0;
  border-radius: var(--r-sm, 8px);
  background: var(--bg-inset, #f1f5f9);
  pointer-events: none;
}

/* Transition is applied only once the indicator has been measured and placed.
   Without this gate it animates from translateY(0) on first paint, so the
   selection appears to fly in from the top of the rail on every visit. */
.settings-rail__slider--primed {
  transition:
    transform 260ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),
    height 260ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));
}

/* Items ride above the indicator so their label and icon stay legible. */
.settings-rail .settings-rail-item {
  position: relative;
  z-index: 1;
}

/* The moving indicator supplies the active fill now, so the per-item version is
   suppressed -- otherwise the destination lights up instantly and there is
   nothing left to slide toward. */
.settings-rail .settings-rail-item.active {
  background: transparent;
}

.settings-rail .settings-rail-item:hover:not(.active) {
  background: transparent;
  color: var(--ink, #0f172a);
}

/* ══ Tab content cross-fade ════════════════════════════════════════════════ */

/* Keyed on the active tab in Settings.jsx, so switching section re-runs this
   instead of swapping content between two frames. */
.settings-pane {
  animation: settings-pane-in 340ms
    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;
}

@keyframes settings-pane-in {
  from { opacity: 0; transform: translate3d(0, 8px, 0); }
  /* \`none\`, not translate3d(0,0,0): releases the compositing layer once the
     pane has settled, so a long form is not left permanently promoted. */
  to   { opacity: 1; transform: none; }
}

/* Cards within a pane arrive just behind it. Capped at four so a long section
   can never strand a card waiting its turn. */
/* TWO DEPTHS, and both are needed. Business / Wallet / Token render their cards
   as direct children of the pane (their tab body is a fragment), while Profile
   wraps its cards in .settings-stack. Selecting only one depth would stagger
   some sections and silently skip others. */
.settings-pane > .rd-card:nth-child(-n + 4),
/* .settings-pane > .settings-stack > .rd-card:nth-child(-n + 4) {
  animation: settings-card-in 380ms
    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;
} */

.settings-pane > .rd-card:nth-child(1),
.settings-pane > .settings-stack > .rd-card:nth-child(1) { animation-delay: 40ms; }
.settings-pane > .rd-card:nth-child(2),
.settings-pane > .settings-stack > .rd-card:nth-child(2) { animation-delay: 90ms; }
.settings-pane > .rd-card:nth-child(3),
.settings-pane > .settings-stack > .rd-card:nth-child(3) { animation-delay: 125ms; }
.settings-pane > .rd-card:nth-child(4),
.settings-pane > .settings-stack > .rd-card:nth-child(4) { animation-delay: 150ms; }

@keyframes settings-card-in {
  from { opacity: 0; transform: translate3d(0, 6px, 0); }
  to   { opacity: 1; transform: none; }
}

/* ══ Narrow screens ═══════════════════════════════════════════════════════ */

@media (max-width: 767px) {
  .settings-hero {
    grid-template-columns: 1fr;
    justify-items: center;
    text-align: center;
    gap: 16px;
  }

  .settings-hero__avatar-wrap {
    --hero-avatar: 96px;
  }

  .settings-hero__todo {
    justify-content: center;
  }

  /* The rail turns into a horizontal scroll strip at this width, so a slider
     measured for a vertical stack would be wrong. Hand the fill back to the
     items. */
  .settings-rail__slider {
    display: none;
  }

  .settings-rail .settings-rail-item.active {
    background: var(--bg-inset, #f1f5f9);
  }
}

/* ══ Reduced motion ═══════════════════════════════════════════════════════
 * Content must still be visible: every animation above ends on its natural
 * state, and \`both\` means that end state is what remains, so disabling them
 * leaves everything shown rather than stuck at opacity 0. */
@media (prefers-reduced-motion: reduce) {
  .settings-hero__avatar,
  .settings-hero__todo li,
  .settings-pane,
  .settings-pane > .rd-card:nth-child(-n + 4),
  .settings-pane > .settings-stack > .rd-card:nth-child(-n + 4) {
    animation: none;
  }

  .settings-hero__ring-fill,
  .settings-rail__slider--primed,
  .settings-hero__chip {
    transition: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/pages/settings.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF,gFAAgF;;AAEhF;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;;sCAIsC;AACtC;EACE,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,wEAAwE;EACxE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,4BAA4B;EAC5B,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,oCAAoC;EACpC,8BAA8B;EAC9B,qBAAqB;EACrB;2DACyD;AAC3D;;AAEA;2BAC2B;AAC3B;EACE,kBAAkB;EAClB,mCAAmC;EACnC,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC;gEAC8D;AAChE;;AAEA;EACE;IACE,UAAU;IACV;uDACmD;IACnD,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;oDACoD;AACpD;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,mDAAmD;EACnD,+FAA+F;EAC/F,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,aAAa;AACf;;AAEA,6EAA6E;;AAE7E;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,0BAA0B;EAC1B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA,6EAA6E;;AAE7E;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE;gEAC8D;AAChE;;AAEA,0EAA0E;AAC1E,uCAAuC,qBAAqB,EAAE;AAC9D,uCAAuC,sBAAsB,EAAE;AAC/D,uCAAuC,sBAAsB,EAAE;AAC/D,uCAAuC,sBAAsB,EAAE;AAC/D,uCAAuC,sBAAsB,EAAE;AAC/D,2CAA2C,sBAAsB,EAAE;;AAEnE;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;kCACkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,sCAAsC;EACtC,oBAAoB;EACpB,mDAAmD;EACnD,4BAA4B;EAC5B,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf;;;2EAGyE;AAC3E;;AAEA;EACE,uCAAuC;EACvC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;;;;;wCAKwC;;AAExC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,UAAU;EACV,+BAA+B;EAC/B,oCAAoC;EACpC,oBAAoB;AACtB;;AAEA;;yEAEyE;AACzE;EACE;;wEAEsE;AACxE;;AAEA,yEAAyE;AACzE;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;kCAEkC;AAClC;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA,+EAA+E;;AAE/E;oDACoD;AACpD;EACE;gEAC8D;AAChE;;AAEA;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD;yEACuE;EACvE,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA;8CAC8C;AAC9C;;;4CAG4C;AAC5C;;;;;;;2DAO2D,qBAAqB,EAAE;AAClF;2DAC2D,qBAAqB,EAAE;AAClF;2DAC2D,sBAAsB,EAAE;AACnF;2DAC2D,sBAAsB,EAAE;;AAEnF;EACE,OAAO,UAAU,EAAE,iCAAiC,EAAE;EACtD,OAAO,UAAU,EAAE,eAAe,EAAE;AACtC;;AAEA,8EAA8E;;AAE9E;EACE;IACE,0BAA0B;IAC1B,qBAAqB;IACrB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;;aAEW;EACX;IACE,aAAa;EACf;;EAEA;IACE,oCAAoC;EACtC;AACF;;AAEA;;;4DAG4D;AAC5D;EACE;;;;;IAKE,eAAe;EACjB;;EAEA;;;IAGE,gBAAgB;EAClB;AACF","sourcesContent":["/* settings.css — Settings shell + profile hero.\n *\n * Loaded from Settings.jsx AFTER responsive/pages/Settings.css, so the rail\n * overrides below outrank that file's `.settings-rail-item.active` rules at\n * equal specificity without needing !important.\n *\n * MOTION BUDGET\n * Everything here animates only opacity, transform and stroke-dashoffset, all\n * of which the compositor can handle without a re-layout. The shared\n * --mx-ease-glide curve comes from PageTransition.css (:root), which\n * DashboardLayout imports, so the whole dashboard eases identically. A literal\n * fallback is given everywhere in case that file is ever not loaded.\n */\n\n/* ══ Profile hero ═══════════════════════════════════════════════════════════ */\n\n.settings-hero {\n  display: grid;\n  grid-template-columns: auto minmax(0, 1fr);\n  gap: 24px;\n  align-items: center;\n}\n\n/* ── Avatar + completion ring ──────────────────────────────────────────────\n * The ring is an SVG rather than a conic-gradient so the sweep can be\n * transitioned: stroke-dashoffset is animatable, background-image is not.\n * Sized in one place via --hero-avatar so the ring, the image and the badge\n * can never drift out of alignment. */\n.settings-hero__avatar-wrap {\n  --hero-avatar: 112px;\n  --hero-ring: 5px;\n  position: relative;\n  width: var(--hero-avatar);\n  height: var(--hero-avatar);\n  flex-shrink: 0;\n}\n\n.settings-hero__ring {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  /* -90deg puts 0% at twelve o'clock; without it the sweep starts at 3. */\n  transform: rotate(-90deg);\n  overflow: visible;\n}\n\n.settings-hero__ring-track {\n  fill: none;\n  stroke: var(--line, #e2e8f0);\n  stroke-width: var(--hero-ring);\n}\n\n.settings-hero__ring-fill {\n  fill: none;\n  stroke: url(#settings-ring-gradient);\n  stroke-width: var(--hero-ring);\n  stroke-linecap: round;\n  transition: stroke-dashoffset 900ms\n    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));\n}\n\n/* Inset by the ring width plus a hair of breathing room, so the portrait never\n   sits under the stroke. */\n.settings-hero__avatar {\n  position: absolute;\n  inset: calc(var(--hero-ring) + 4px);\n  border-radius: 50%;\n  overflow: hidden;\n  display: grid;\n  place-items: center;\n  background: var(--bg-inset, #f1f5f9);\n  animation: settings-avatar-in 520ms\n    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;\n}\n\n@keyframes settings-avatar-in {\n  from {\n    opacity: 0;\n    /* Scale is acceptable here, unlike on text: a circular mark has no glyphs\n       to re-rasterise, so it stays crisp throughout. */\n    transform: scale(0.9);\n  }\n  to {\n    opacity: 1;\n    transform: none;\n  }\n}\n\n.settings-hero__avatar img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Initials fallback. No portrait field exists on the account, so this is the\n   real default rather than a placeholder graphic. */\n.settings-hero__initials {\n  font-size: 30px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: var(--brand-600, #7c3aed);\n  user-select: none;\n}\n\n.settings-hero__pct {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  min-width: 42px;\n  padding: 3px 7px;\n  border-radius: 999px;\n  background: var(--surface, var(--bg-primary, #fff));\n  box-shadow: 0 0 0 2px var(--surface, var(--bg-primary, #fff)), 0 2px 8px rgba(15, 23, 42, 0.14);\n  font-size: 12px;\n  font-weight: 600;\n  text-align: center;\n  color: var(--ink, #0f172a);\n  display: none;\n}\n\n/* ── Hero copy ─────────────────────────────────────────────────────────── */\n\n.settings-hero__body {\n  min-width: 0;\n}\n\n.settings-hero__name {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: var(--ink, #0f172a);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.settings-hero__email {\n  display: block;\n  margin-top: 2px;\n  font-size: 13px;\n  color: var(--t-400, #64748b);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.settings-hero__progress-label {\n  margin-top: 14px;\n  font-size: 12.5px;\n  color: var(--t-500, #475569);\n}\n\n/* ── Checklist ─────────────────────────────────────────────────────────── */\n\n.settings-hero__todo {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 12px 0 0;\n  padding: 0;\n  list-style: none;\n}\n\n.settings-hero__todo li {\n  animation: settings-todo-in 380ms\n    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;\n}\n\n/* Staggered so the list assembles rather than snapping in as one block. */\n.settings-hero__todo li:nth-child(1) { animation-delay: 60ms; }\n.settings-hero__todo li:nth-child(2) { animation-delay: 100ms; }\n.settings-hero__todo li:nth-child(3) { animation-delay: 135ms; }\n.settings-hero__todo li:nth-child(4) { animation-delay: 165ms; }\n.settings-hero__todo li:nth-child(5) { animation-delay: 190ms; }\n.settings-hero__todo li:nth-child(n + 6) { animation-delay: 210ms; }\n\n@keyframes settings-todo-in {\n  from { opacity: 0; transform: translate3d(0, 5px, 0); }\n  to   { opacity: 1; transform: none; }\n}\n\n/* Each chip navigates to the tab that owns the field, so the list is a set of\n   shortcuts, not just a report. */\n.settings-hero__chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 11px 6px 9px;\n  border: 1px solid var(--line, #e2e8f0);\n  border-radius: 999px;\n  background: var(--surface, var(--bg-primary, #fff));\n  color: var(--t-500, #475569);\n  font: inherit;\n  font-size: 12.5px;\n  cursor: pointer;\n  transition:\n    border-color 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),\n    color 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),\n    transform 160ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));\n}\n\n.settings-hero__chip:hover {\n  border-color: var(--brand-600, #7c3aed);\n  color: var(--ink, #0f172a);\n  transform: translateY(-1px);\n}\n\n.settings-hero__chip:focus-visible {\n  outline: 2px solid var(--brand-600, #7c3aed);\n  outline-offset: 2px;\n}\n\n.settings-hero__chip svg {\n  flex-shrink: 0;\n  color: var(--t-400, #94a3b8);\n}\n\n.settings-hero__done {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  margin-top: 12px;\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--ok, var(--success, #15803d));\n}\n\n/* ══ Rail: sliding active indicator ════════════════════════════════════════\n * Replaces the per-item `background` on .settings-rail-item.active. With the\n * background painted on each item, switching section snapped: one item's fill\n * vanished and another appeared in the same frame with nothing connecting\n * them. A single element now carries the fill and is moved between items.\n * Same technique as the main Sidebar. */\n\n.settings-rail {\n  position: relative;\n}\n\n.settings-rail__slider {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  z-index: 0;\n  border-radius: var(--r-sm, 8px);\n  background: var(--bg-inset, #f1f5f9);\n  pointer-events: none;\n}\n\n/* Transition is applied only once the indicator has been measured and placed.\n   Without this gate it animates from translateY(0) on first paint, so the\n   selection appears to fly in from the top of the rail on every visit. */\n.settings-rail__slider--primed {\n  transition:\n    transform 260ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)),\n    height 260ms var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1));\n}\n\n/* Items ride above the indicator so their label and icon stay legible. */\n.settings-rail .settings-rail-item {\n  position: relative;\n  z-index: 1;\n}\n\n/* The moving indicator supplies the active fill now, so the per-item version is\n   suppressed -- otherwise the destination lights up instantly and there is\n   nothing left to slide toward. */\n.settings-rail .settings-rail-item.active {\n  background: transparent;\n}\n\n.settings-rail .settings-rail-item:hover:not(.active) {\n  background: transparent;\n  color: var(--ink, #0f172a);\n}\n\n/* ══ Tab content cross-fade ════════════════════════════════════════════════ */\n\n/* Keyed on the active tab in Settings.jsx, so switching section re-runs this\n   instead of swapping content between two frames. */\n.settings-pane {\n  animation: settings-pane-in 340ms\n    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;\n}\n\n@keyframes settings-pane-in {\n  from { opacity: 0; transform: translate3d(0, 8px, 0); }\n  /* `none`, not translate3d(0,0,0): releases the compositing layer once the\n     pane has settled, so a long form is not left permanently promoted. */\n  to   { opacity: 1; transform: none; }\n}\n\n/* Cards within a pane arrive just behind it. Capped at four so a long section\n   can never strand a card waiting its turn. */\n/* TWO DEPTHS, and both are needed. Business / Wallet / Token render their cards\n   as direct children of the pane (their tab body is a fragment), while Profile\n   wraps its cards in .settings-stack. Selecting only one depth would stagger\n   some sections and silently skip others. */\n.settings-pane > .rd-card:nth-child(-n + 4),\n/* .settings-pane > .settings-stack > .rd-card:nth-child(-n + 4) {\n  animation: settings-card-in 380ms\n    var(--mx-ease-glide, cubic-bezier(0.22, 0.61, 0.36, 1)) both;\n} */\n\n.settings-pane > .rd-card:nth-child(1),\n.settings-pane > .settings-stack > .rd-card:nth-child(1) { animation-delay: 40ms; }\n.settings-pane > .rd-card:nth-child(2),\n.settings-pane > .settings-stack > .rd-card:nth-child(2) { animation-delay: 90ms; }\n.settings-pane > .rd-card:nth-child(3),\n.settings-pane > .settings-stack > .rd-card:nth-child(3) { animation-delay: 125ms; }\n.settings-pane > .rd-card:nth-child(4),\n.settings-pane > .settings-stack > .rd-card:nth-child(4) { animation-delay: 150ms; }\n\n@keyframes settings-card-in {\n  from { opacity: 0; transform: translate3d(0, 6px, 0); }\n  to   { opacity: 1; transform: none; }\n}\n\n/* ══ Narrow screens ═══════════════════════════════════════════════════════ */\n\n@media (max-width: 767px) {\n  .settings-hero {\n    grid-template-columns: 1fr;\n    justify-items: center;\n    text-align: center;\n    gap: 16px;\n  }\n\n  .settings-hero__avatar-wrap {\n    --hero-avatar: 96px;\n  }\n\n  .settings-hero__todo {\n    justify-content: center;\n  }\n\n  /* The rail turns into a horizontal scroll strip at this width, so a slider\n     measured for a vertical stack would be wrong. Hand the fill back to the\n     items. */\n  .settings-rail__slider {\n    display: none;\n  }\n\n  .settings-rail .settings-rail-item.active {\n    background: var(--bg-inset, #f1f5f9);\n  }\n}\n\n/* ══ Reduced motion ═══════════════════════════════════════════════════════\n * Content must still be visible: every animation above ends on its natural\n * state, and `both` means that end state is what remains, so disabling them\n * leaves everything shown rather than stuck at opacity 0. */\n@media (prefers-reduced-motion: reduce) {\n  .settings-hero__avatar,\n  .settings-hero__todo li,\n  .settings-pane,\n  .settings-pane > .rd-card:nth-child(-n + 4),\n  .settings-pane > .settings-stack > .rd-card:nth-child(-n + 4) {\n    animation: none;\n  }\n\n  .settings-hero__ring-fill,\n  .settings-rail__slider--primed,\n  .settings-hero__chip {\n    transition: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
